module.exports = "pegasus_template/assets/image-text-button-share-preview.png";